import { render, staticRenderFns } from "./PostnordPrognos.vue?vue&type=template&id=2ddb188e&"
import script from "./PostnordPrognos.vue?vue&type=script&lang=js&"
export * from "./PostnordPrognos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports